import axios from "axios";
import { baseURL } from "./consts";

export const api = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
  },
});
